import { c as _c } from "react/compiler-runtime";
import { LOCALE } from '@/constants/config';
import useCartFormPhone from '@/contexts/cartContext/hooks/useCartFormPhone';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import usePageFormErrors from '@/contexts/pageContext/hooks/usePageFormErrors';
import { PhoneField } from '@winelidays/wld-tsx-2/fields';
import { getPhoneCountryCode } from '@winelidays/wld-tsx-2/utils';
const PhoneForm = (t0) => {
    const $ = _c(17);
    const { formId, disabled } = t0;
    const translate = useTranslate();
    const { phoneNumber, setPhoneNumber, phoneCountry, setPhoneCountry, phoneError, setIsPhoneInError } = useCartFormPhone();
    const { showFormErrors, setShowFormErrors } = usePageFormErrors(formId);
    let t1;
    if ($[0] !== setPhoneCountry || $[1] !== setPhoneNumber || $[2] !== setShowFormErrors) {
        t1 = (value, country) => {
            setPhoneNumber(value);
            setPhoneCountry(country);
            setShowFormErrors(false);
        };
        $[0] = setPhoneCountry;
        $[1] = setPhoneNumber;
        $[2] = setShowFormErrors;
        $[3] = t1;
    }
    else {
        t1 = $[3];
    }
    const handleChange = t1;
    let t2;
    if ($[4] !== phoneCountry) {
        t2 = phoneCountry && phoneCountry.countryCode || getPhoneCountryCode(undefined, LOCALE);
        $[4] = phoneCountry;
        $[5] = t2;
    }
    else {
        t2 = $[5];
    }
    const country_0 = t2;
    let t3;
    if ($[6] !== country_0 || $[7] !== disabled || $[8] !== formId || $[9] !== handleChange || $[10] !== phoneCountry || $[11] !== phoneError || $[12] !== phoneNumber || $[13] !== setIsPhoneInError || $[14] !== showFormErrors || $[15] !== translate) {
        t3 = <PhoneField formId={formId} value={phoneNumber} phoneCountry={phoneCountry} country={country_0} onChange={handleChange} error={phoneError} setErrorStatus={setIsPhoneInError} showError={showFormErrors} mobile={true} required={true} translate={translate} locale={LOCALE} disabled={disabled}/>;
        $[6] = country_0;
        $[7] = disabled;
        $[8] = formId;
        $[9] = handleChange;
        $[10] = phoneCountry;
        $[11] = phoneError;
        $[12] = phoneNumber;
        $[13] = setIsPhoneInError;
        $[14] = showFormErrors;
        $[15] = translate;
        $[16] = t3;
    }
    else {
        t3 = $[16];
    }
    return t3;
};
export default PhoneForm;
